// ===========================================
// What an invoice line is for: Tuition / Product / Other (#372 study §7.5)
// ===========================================
// Always shown on a typed line (default Other). A system-made line (generated tuition, a product
// line) is LOCKED: the server keeps its kind whatever is sent, so the picker is disabled and says
// why. The kind decides which invoices a late fee charges.

import { Box, MenuItem, TextField, Tooltip } from '@mui/material';
import type { InvoiceLineKind } from '../../api/invoices.api';

const LINE_KIND_LABEL: Record<InvoiceLineKind, string> = {
  TUITION: 'Tuition',
  PRODUCT: 'Product',
  OTHER: 'Other',
};

export interface LineKindSelectProps {
  value: InvoiceLineKind;
  locked?: boolean;
  disabled?: boolean;
  onChange: (kind: InvoiceLineKind) => void;
}

export default function LineKindSelect({ value, locked = false, disabled = false, onChange }: LineKindSelectProps) {
  const field = (
    <TextField
      select
      fullWidth
      size="small"
      label="Kind"
      value={value}
      disabled={disabled || locked}
      onChange={(e) => onChange(e.target.value as InvoiceLineKind)}
    >
      {(Object.keys(LINE_KIND_LABEL) as InvoiceLineKind[]).map((kind) => (
        <MenuItem key={kind} value={kind}>
          {LINE_KIND_LABEL[kind]}
        </MenuItem>
      ))}
    </TextField>
  );
  return locked ? (
    <Tooltip title="Set by the system">
      {/* A disabled input fires no events: a block wrapper carries the tooltip and keeps the
          full-width field at full width. */}
      <Box component="span" sx={{ display: 'block' }}>
        {field}
      </Box>
    </Tooltip>
  ) : (
    field
  );
}
